import { FilterValues } from 'commons/types/DTO/commons'

export type UseWebPageProps = {
  createdById: string | null
  currentOwnerId: string | null
  page: number
  searchQuery: string
  size: number
  sortAsc: boolean
  sortField: string
  status: string | null
}

export type Application = {
  companyName: string
  contactEmail: string
  contactName: string
  contactPhone: string
  enableDeleteApplication: boolean
  enableGetLink: boolean
  getApplicationActionName: string
  id: number
  lastModified: string
  showCreatedBy: string
  showCurrentOwner: string
  showInternalBankNotes: string
  status: string
}

export type WebPage = {
  applications: Application[]
  creatorOptions: FilterValues[]
  enableCreateApplication: boolean
  form: UseWebPageProps
  ownerOptions: FilterValues[]
  showEnableChooseExistingRelationship: boolean
  statusOptions: FilterValues[]
  totalCount: number
}
